// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportTabs_root__x8zzB","tab":"ReportTabs_tab__3Cxtb","tab--active":"ReportTabs_tab--active__8MDPV","label":"ReportTabs_label__3ea-3","icon":"ReportTabs_icon__3-pQN"};